import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface NewsfeedDisplaySettings {
  fadeoutSeen: boolean;
  dimResolved: boolean;
}

const DEFAULT_SETTINGS: NewsfeedDisplaySettings = {
  fadeoutSeen: true,
  dimResolved: true,
};

@Injectable({
  providedIn: 'root',
})
export class NewsfeedDisplaySettingsService {
  private settings$ = new BehaviorSubject<NewsfeedDisplaySettings>(
    DEFAULT_SETTINGS,
  );

  getSettings(): Observable<NewsfeedDisplaySettings> {
    return this.settings$.asObservable();
  }

  getCurrentSettings(): NewsfeedDisplaySettings {
    return this.settings$.getValue();
  }

  setFadeoutSeen(value: boolean): void {
    const current = this.settings$.getValue();
    this.settings$.next({ ...current, fadeoutSeen: value });
  }

  setDimResolved(value: boolean): void {
    const current = this.settings$.getValue();
    this.settings$.next({ ...current, dimResolved: value });
  }

  updateSettings(partial: Partial<NewsfeedDisplaySettings>): void {
    const current = this.settings$.getValue();
    this.settings$.next({ ...current, ...partial });
  }
}
